import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="app-loader-overlay">
      <div className="app-loader-spinner"></div>
    </div>
  );
};

export default Loader;
